module.exports = __webpack_public_path__ + "img/icon2.6720fb17.png";